module.exports = __webpack_public_path__ + "img/ball_5_transparent.2005b3c9.png";